<template>
  <div class="input">
    <!--    <span class="star" v-if="star">{{"*".repeat(data.length)}}</span>-->
    <input
      ref="input"
      :type="inputType"
      v-model="value"
      autocomplete="off"
      :disabled="disabled"
      :maxlength="maxlength"
      @keydown="keydown"
      @keyup="keyup"
      @blur="blur"
      @focus="focus"
    />
    <span
      ref="placeholder"
      class="placeholder"
      @click="passwordFocus"
      v-show="data.length===0">{{ placeholder }}</span>
    <!--    <span ref="visible" class="visible iconfont" :class="visibleCls" @click="changeVisible"></span>-->
  </div>
</template>

<script>
import Schema from 'async-validator';
export default {
  name: 'AuthFormInputPassword',
  props: {
    maxlength: Number,
    placeholder: {
      type: String,
    },
    rule: {
      type: [Object, Array],
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      value: '',
      data: '',
      validator: null,
      star: false,
      inputType: 'password',
    };
  },
  computed: {
    visibleCls() {
      return this.star ? 'icon-biyan' : 'icon-kanjian';
    },
  },
  watch: {
    value(val) {
      if (val) {
        if (this.star) {
          if (this.data.length === this.maxlength) {
            this.value = '';
            return;
          }
          if (/.*[\u4e00-\u9fa5]+.*$/.test(val)) {
            this.value = val.replace(/[\u4e00-\u9fa5]/gm, '');
            return;
          }
          this.data += val;
          if (this.star) {
            this.value = '';
          }
        } else {
          if (/.*[\u4e00-\u9fa5]+.*$/.test(val)) {
            this.value = val.replace(/[\u4e00-\u9fa5]/gm, '');
            return;
          }
          this.data = this.value;
        }
      }
    },
  },
  methods: {
    passwordFocus() {
      this.$refs['input'].focus();
    },
    check() {
      return new Promise((resolve) => {
        this.validate().then(() => {
          this.$emit('validator', true);
          resolve(true);
        }, (msg) => {
          this.$emit('validator', msg);
          resolve(false);
        });
      });
    },
    validate() {
      return new Promise((resolve, reject) => {
        new Schema({
          value: this.rule,
        }).validate({value: this.data}, (err) => {
          if (err) {
            reject(err[0].message);
          } else {
            resolve();
          }
        });
      });
    },
    addEvent() {
      const input = this.$refs['input'];
      input.addEventListener('focus', this.focus);
      input.addEventListener('blur', this.blur);
      const placeholder = this.$refs['placeholder'];
      placeholder.addEventListener('click', this.placeholderClick);
    },
    removeEvent() {
      const input = this.$refs['input'];
      const placeholder = this.$refs['placeholder'];
      input.removeEventListener('focus', this.focus);
      input.removeEventListener('blur', this.blur);
      placeholder.removeEventListener('click', this.placeholderClick);
    },
    keydown(e) {
      if (e.keyCode === 8 && this.star) {
        this.data = this.data.slice(0, this.data.length - 1);
      }
      if (e.keyCode === 8 && this.data.length === 1) {
        this.data = '';
      }
    },
    keyup(e) {
      this.$emit('input', this.data);
      if (e.keyCode === 13) {
        this.$emit('keyup-enter');
      }
    },
    focus() {
      this.$refs['placeholder'].classList.add('hide');
      // this.$emit("validator", true);
    },
    blur() {
      this.validate().then(() => {
        this.$emit('validator', true);
      }, (msg) => {
        this.$emit('validator', msg);
      });
      const placeholder = this.$refs['placeholder'];
      placeholder.classList.remove('hide');
    },
    placeholderClick(e) {
      e.target.classList.add('hide');
      this.$refs['input'].focus();
    },
    changeVisible() {
      this.star = !this.star;
      if (this.star) {
        this.value = '';
        this.inputType = 'password';
      } else {
        this.value = this.data;
        this.inputType = 'text';
      }
    },
  },
};
</script>

<style lang="scss" scoped>
input {
  ime-mode: disabled;
  color: rgba(0,0,0,.45);
}
.star {
  padding-top: 9px;
  user-select: none;
}
.placeholder {
  user-select: none;
  position: absolute;
  top: 7px;
  left: 0;
  color: rgba(0,0,0,.45);

  &.hide {
    display: none;
  }
}
.visible {
  position: absolute;
  top: 5px;
  right: 0;
  height: 24px;
  width: 24px;
  text-align: center;
  font-size: 16px;
  cursor: pointer;
  &:hover {
    color: #1890ff;
  }
}
</style>
